import './device-buttons.scss'
import React from 'react'

interface DeviceButtonsProps {
	onDeviceClick: any
	fromBubble?: boolean
}

const DeviceButtons: React.FC<DeviceButtonsProps> = ({ onDeviceClick, fromBubble = false }) => {
	return (
		<div className='t-direct-access-install__buttons'>
			<button
				className='t-direct-access-install__button t-direct-access-install__button--iphone'
				onClick={() => onDeviceClick(false)}
			>
				iPhone
			</button>
			<button className='t-direct-access-install__button' onClick={() => onDeviceClick(true)}>
				Android
			</button>
			{fromBubble && (
				<button className='t-direct-access-install__button' onClick={() => onDeviceClick(null)}>
					Navegador web
				</button>
			)}
		</div>
	)
}

export default DeviceButtons
